import api from "skin/http"

export default function company(value) {
	return new Promise((resolve, reject) => {
		if (!value) return reject(fail('custom.missing', 'Укажите ИНН', 0));
		value = value.trim()
		if (![10, 12].includes(value.length)) return reject(fail('custom.invalid', 'Указан некорректный ИНН', 0));
		const opt = {
			method: 'GET',
			url: 'api/other/signup/company/' + value,
			headers: { nowait: true }
		}
		api(opt)
			.then(r => {
				const d = r.data
				if (!d) return reject(fail('custom.empty', 'По данному ИНН не найдено компании', 1));
				const postName = d.data.management?.post;
				const role = postName || 'Руководитель';
				const kl = d.data.address.data
				const manager = d.data.type === 'INDIVIDUAL' ? `${d.data.fio.surname} ${d.data.fio.name} ${d.data.fio.patronymic}` : d.data.management?.name;
				const data = {
					type: d.data.type,
					inn: d.data.inn,
					offName: d.value,
					manager: manager,
					managerTitle: role,
					ogrn: d.data.ogrn,
					kpp: d.data.kpp,
					kladrId: kl.city_kladr_id ?? kl.settlement_kladr_id,
					address: d.data.type === 'LEGAL' ? d.data.address?.unrestricted_value : '',
				};
				resolve(data);
			})
			.catch(err => {
				const msg = err?.response?.data;
				if (msg && typeof msg === 'string') {
					return reject(fail('custom.empty', msg, 1));
				}
				reject(err);
			})
	})
}

function fail(code, message, p = 0) {
	return {
		custom: true,
		priority: p,
		code,
		message
	}
}